<template>
  <div class="flex flex-col w-full">
  
    <div v-if="call">

      <Call :call="call" />

    </div>

    <div v-else>
      <Hero :baseUrl="data.baseUrl" :custom="getSectionData('hero')"/>

      <div v-for="section in sections" :key="section.title" :id="section.id">
        <Custom v-if="section.type == 'custom'" :custom="section" html=true />
        <Events v-if="section.type == 'events'" :data="events" :baseUrl="data.baseUrl" :custom="eventsConfig" />
      </div>
    </div>

  </div>
</template>

<script>
import data from "@/data/config.json";
import axios from "axios";
import moment from "moment";

import Hero from "@/components/Hero.vue";
import Custom from "@/components/Custom.vue";
import Events from "@/components/Events.vue";
import Call from "@/views/Call.vue";

export default {
  name: "home",
  data() {
    return {
      data,
      events: null,
      sections: null,
      eventsConfig: null,
      call: null
    };
  },
  components: {
    Events,
    Hero,
    Custom,
    Call
  },
  created() {
    if (this.data.configId) {
      axios.get(
        `https://edgeryders.eu/webkit_components/topics.json?serializer=event&tags=webcontent`
      ).then(({ data }) => {
        var post = data.find(post => post.id === this.data.configId);
        var json = this.getJson(post.cooked);
        this.sections = json.sections;
        this.eventsConfig = this.getSectionData('events');
        this.getEvents(this.eventsConfig.tag);
      });
    } else {
      this.sections = this.data.sections;
    };
  },
  methods: {
    getSectionData(type) {
      return this.sections.find(section => section.type === type) || {};
    },
    getEvents(tag) {
      axios.get(
        `https://edgeryders.eu/webkit_components/topics.json?serializer=event&tags=${tag}&per=500`
      ).then(({ data }) => {
        this.events = data.filter(({ event }) => event)
          .map(event => ({
            ...event,
            date: this.formatDate(event.event.start),
            json: this.getJson(event.cooked)
          }))
          .sort((a, b) => a.event.start.localeCompare(b.event.start));
          this.getCall();
      });
    },
    formatDate(value) {
      return moment(value).format("D-M-YYYY");
    },
    getCall() {
      var slug = this.$route.params.id;
      var call = this.events.filter(event => this.getSlug(event.title) == slug);
      if (call) {
        this.call = call[0];
      } else {
        this.call = null;
      }
    },
    getNavElements() {
      if (this.sections.length) {
      var navArray = this.sections.map(function(el) {
            if (el.id) {
              return {
                title: el.title,
                id: el.id,
              } 
            }
          });
      return navArray.filter(function (el) {
          return el != null;
      });
      }
    }
  },
  computed: {
  }
};
</script>
